
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  z-index:3;
}

ul{
  list-style:none;
}

.nav--main-list{
  display:flex;
  height:123px;
  width:100%;
  padding:0;
  background-color:var(--color-neutral-white);
  z-index:1;
}

.nav--main-list li{
    display:flex;
    height:100%;
    align-items:center;
  }

.nav--main-list.mobile{
  position:relative;
  flex-direction:column;
  padding-left:0;
  padding-right:0;
  height:-moz-fit-content;
  height:fit-content;
  margin:0;
  padding-top:1rem;
}

.nav--main-list.mobile li{
    transition:0.5s;
    border-bottom:1px solid var(--color-neutral-lighter);
  }

.nav--main-list.mobile li:first-of-type:not(.back){
    border-top:1px solid var(--color-neutral-lighter);
  }

@media (prefers-reduced-motion: reduce){
  .nav--main-list.mobile li{
    transition:none;
  }
}

.flyaway{
  transform:translateX(-150%);
  visibility:hidden;
  opacity:0;
  margin:0 !important;
  height:0 !important;
  border:none !important;
  padding:0 !important;
}
`;